const PLUGIN_TOOLBAR_BUTTON_ID = {
  DELETE: "delete",
  ALIGNMENT: "alignment",
  SETTINGS: "settings",
  REPLACE: "replace",
  LINK: "link",
  SIZE: "size",
  SEPARATOR: "separator"
};
export {
  PLUGIN_TOOLBAR_BUTTON_ID
};
//# sourceMappingURL=pluginToolbarButtonsIds.js.map
